module.exports = __webpack_public_path__ + "media/bootstrap-icons/coin-fe78893c.svg";